import { Directive, ElementRef, Input } from '@angular/core';
import Chart from 'chart.js/auto';

@Directive({
  selector: '[appChartJs]',
  standalone: true
})
export class ChartJsDirective {
  @Input() chartConfig: any
  
  chart: Chart;
  ctx: any;
  constructor(private el: ElementRef) { }

  ngOnChanges(changes: any) {
    if (changes['chartConfig'] && changes['chartConfig'].previousValue != changes['chartConfig'].currentValue) {
      if (this.chart) {
        Object.assign(this.chart.config, this.chartConfig);
        this.chart.update();
      }
      else {
        this.ctx = this.el.nativeElement.getContext('2d');
        this.chart = new Chart(this.ctx, this.chartConfig);
      }
    }
  }
}
